/*
 * @description:
 * @author: cuicui
 * @Date: 2023-01-20 00:07:46
 * @LastEditTime: 2023-01-31 21:44:20
 * @LastEditors: cuicui
 */
export const STATUS = {
  ERROR: 'ERROR',
  AGREE: 'AGREE',
  SUCCESS: 'SUCCESS',
  waiting_for_approval: 'waiting_for_approval',
  canceled: 'canceled',
};
export const STATUS_zh = {
  ERROR: '审核失败',
  AGREE: '已接受资料',
  SUCCESS: '审核成功',
  waiting_for_approval: '未审核',
  canceled: '已撤销',
};
export const TYPE = {
  PERSONAL: 'PERSONAL',
  ENTERPRISE: 'ENTERPRISE'
};
export const TYPE_zh = {
  PERSONAL: '审核通过',
  ENTERPRISE: '审核失败'
};
